import { Button as MaterialButton } from '@mui/material';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledIcon = styled.span`
  display: inline-flex;
  padding-right: 8px;
`;

interface ButtonProps {
  label: string;
  icon?: React.ReactNode;
  backgroundColor: string;
  hoverBackgroundColor: string;
  textColor: string;
  fullWidth?: boolean;
  showShadow?: boolean;
  borderColor?: string;
  onClick?: () => any;
}

const Button = ({
  label,
  icon = null,
  backgroundColor,
  hoverBackgroundColor,
  textColor,
  fullWidth = false,
  showShadow = true,
  borderColor = 'transparent',
  onClick
}: ButtonProps) => {
  return (
    <MaterialButton
      variant="contained"
      onClick={onClick}
      sx={{
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        borderRadius: '100px',
        padding: '10px 24px',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
        letterSpacing: '0.1px',
        textTransform: 'none',
        color: textColor,
        backgroundColor: backgroundColor,
        boxShadow: showShadow ? 'auto' : 'none',
        border: borderColor
          ? `1px solid ${borderColor}`
          : '1px solid transparent',
        width: fullWidth ? '100%' : 'auto',
        '&:hover': {
          backgroundColor: hoverBackgroundColor
        }
      }}
    >
      <StyledWrapper>
        {icon && <StyledIcon>{icon}</StyledIcon>}
        <span>{label}</span>
      </StyledWrapper>
    </MaterialButton>
  );
};

export default Button;
